module.exports = __webpack_public_path__ + "static/media/lidi.94e304d3.png";